import { AbstractControl, ValidatorFn } from '@angular/forms';

// TODO(tbottonari): implement validators.
export function requiredGroupValidator(groupName: string, required: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => null;
}

export function requiredOneOfValidator(groupName: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => null;
}
